import {createI18n} from 'vue-i18n'
import {accountGroups, accountMapper, accountsEN, accountsNB} from '@tritt/conta-bookkeeping-accounts'
import {anonymousGet} from '@/services/infrastructure/api.service'


const fetchLanguageFile = async (language: string, translationFile: string) => {
    return await anonymousGet(`/translation/${translationFile}/${language}`)
}

const createI18nInstance = async () => {
    const en = await fetchLanguageFile('en', 'locales')
    const nb = await fetchLanguageFile('nb', 'locales')
    const vatNb = await fetchLanguageFile('nb', 'vatCodes')
    const vatEn = await fetchLanguageFile('en', 'vatCodes')

    const messages = {
        NB: {
            account: accountMapper.mapToAccountInformation(accountsNB),
            'account-groups': accountGroups.NB,
            'vat-codes': vatNb,
            ...nb,
        },
        EN: {
            account: accountMapper.mapToAccountInformation(accountsEN),
            'account-groups': accountGroups.EN,
            'vat-codes': vatEn,
            ...en,
        }
    }
    const i18n = createI18n({
        legacy: false,
        locale: 'NB', // set locale
        fallbackLocale: 'EN', // set fallback locale
        messages
    })
    return i18n
}

let i18nInstance: any

const initializeI18n = async () => {
    if (!i18nInstance) {
        i18nInstance = await createI18nInstance()
    }
    return i18nInstance
}

const getI18nInstance = () => i18nInstance


export {
    initializeI18n, getI18nInstance
}